import { Reducer } from "redux";
import {
    AUTHENTICATE_USER,
    SET_ALREADY_SUBMITTED_STATE,
    SET_COMMUNICATION_ERROR_STATUS,
    SET_VALID_LOGIN_STATUS
} from "./constants";
import {
    authenticateUserHandler,
    changeLoginInformationAlreadySubmissionStateHandler,
    changeMyleCommunicationIssuesHandler,
    changeValidLoginStateHandler
} from "./handlers";
import {
    AuthenticateUserAction,
    ChangeLoginInformationAlreadySubmissionStateAction,
    LoginActions,
    LoginState,
    ToggleInvalidLoginAction,
    ToggleMyleCommunicationIssuesStateAction,
    LoginErrorCodes
} from "./type";

export const initialState: LoginState = {
    isAuthenticated: false,
    isAlreadySubmitted: false,
    isValidLogin: true,
    loginErrorCode: LoginErrorCodes.None,
    isHavingIssuesWithConnectionToMyle: false
};

const reducer: Reducer<LoginState> = (state: LoginState = initialState, action: LoginActions) => {
    switch (action.type) {
        case AUTHENTICATE_USER:
            return authenticateUserHandler(state, action as AuthenticateUserAction);

        case SET_ALREADY_SUBMITTED_STATE:
            return changeLoginInformationAlreadySubmissionStateHandler(state, action as ChangeLoginInformationAlreadySubmissionStateAction);

        case SET_VALID_LOGIN_STATUS:
            return changeValidLoginStateHandler(state, action as ToggleInvalidLoginAction);

        case SET_COMMUNICATION_ERROR_STATUS:
            return changeMyleCommunicationIssuesHandler(state, action as ToggleMyleCommunicationIssuesStateAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Login/reducer.ts